module.exports = __webpack_public_path__ + "static/media/galdinsWon_1000_2500.ca97bc4f.png";